/**
 * Best-effort E.164 phone normalization, US-default - the Register-to-bid
 * form saves through this so bid_contacts.phone is always SMS-addressable.
 * Mirrors functions/_lib/notify.ts (server side) - keep the two in sync.
 *
 * Returns null when the input can't be a real mobile number; callers show a
 * validation error rather than saving junk.
 */
export function normalizePhone(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const hasPlus = raw.trim().startsWith('+');
  const digits = raw.replace(/\D/g, '');
  if (!digits) return null;
  if (hasPlus) {
    if (digits.length < 8 || digits.length > 15 || digits[0] === '0') return null;
    return `+${digits}`;
  }
  // No country code: assume US/Canada.
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits[0] === '1') return `+${digits}`;
  return null;
}
